import React from "react";
import {
  FiPlus,
  FiDownload,
  FiUpload,
  FiFileText,
  FiX,
} from "react-icons/fi";
import { Button } from "newui/components/Button";
import { useClarificationsRegisterContext } from "./ClarificationsRegisterContext";

export const ClarificationsRegisterHeader: React.FC = () => {
  const { data, filters, modals, props } = useClarificationsRegisterContext();
  const { isClientView, rfxSubmissionId } = props;
  const { mergedClarifications, handleExport, handleDownloadTemplate } = data;
  const { activeFilterCount, activeFilterDetails, handleClearAllFilters, handleRemoveSupplierFilter, handleRemoveStatusFilter, handleRemoveImpactFilter } = filters;
  const { handleOpenCreateModal, fileInputRef, handleFileSelect } = modals;

  return (
    <div className="flex flex-wrap items-center justify-between gap-4 border-b border-gray-200 px-4 py-4">
      <div className="flex items-center gap-4 flex-1">
        <div>
          <h3 className="text-lg font-semibold text-gray-900">Clarifications Register</h3>
          <p className="text-sm text-gray-500">
            {isClientView
              ? "Manage clarification requests sent to suppliers"
              : "View and respond to clarification requests"}
          </p>
        </div>
        {activeFilterCount > 0 && (
          <div className="flex items-center gap-3 flex-wrap">
            <Button
              onClick={handleClearAllFilters}
              btntype="base"
              className="flex items-center gap-1 !py-1 !px-2 !text-sm"
              title="Clear all filters"
            >
              <FiX className="h-3 w-3" />
              Clear All
            </Button>
            <div className="flex flex-wrap gap-2">
              {activeFilterDetails.map((detail, index) => (
                <button
                  key={index}
                  onClick={() => {
                    if (detail.type === "supplier") {
                      handleRemoveSupplierFilter(detail.value);
                    } else if (detail.type === "status") {
                      handleRemoveStatusFilter(detail.value);
                    } else if (detail.type === "impact") {
                      handleRemoveImpactFilter(detail.value);
                    }
                  }}
                  className="flex items-center gap-1 rounded-full bg-blue-100 px-3 py-1 text-xs font-medium text-blue-700 hover:bg-blue-200 transition-colors"
                  title={`Remove ${detail.label} filter`}
                >
                  <span>{detail.label}</span>
                  <FiX className="h-3 w-3" />
                </button>
              ))}
            </div>
          </div>
        )}
      </div>
      {rfxSubmissionId && (
        <div className="flex flex-wrap items-center gap-2">
          {mergedClarifications?.length > 0 && <Button
            onClick={handleExport}
            btntype="base"
            className="flex items-center gap-2"
            title="Export clarifications"
          >
            <FiDownload className="h-4 w-4" />
            Export
          </Button>}
          {isClientView && <><Button
            onClick={handleDownloadTemplate}
            btntype="base"
            className="flex items-center gap-2"
            title="Download import template"
          >
            <FiFileText className="h-4 w-4" />
            Template
          </Button>
            <Button
              onClick={() => fileInputRef.current?.click()}
              btntype="base"
              className="flex items-center gap-2"
              title="Import clarifications"
            >
              <FiUpload className="h-4 w-4" />
              Import
            </Button>
            <input
              ref={fileInputRef}
              type="file"
              accept=".xlsx,.xls,.csv"
              onChange={handleFileSelect}
              className="hidden"
            /></>}
          {isClientView && <Button
            onClick={handleOpenCreateModal}
            className="flex items-center gap-2"
            data-testid="add-clarification-button"
          >
            <FiPlus className="h-4 w-4" />
            Add Clarification
          </Button>}
        </div>
      )}
    </div>
  );
};
